export function IconHand({ className }: Readonly<{ className?: string }>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M18.5 9.5V5.75a1.25 1.25 0 0 0-2.5 0M16 9.5V4.25a1.25 1.25 0 0 0-2.5 0V9.5M13.5 5.5V3.25a1.25 1.25 0 0 0-2.5 0v7.25M8 14.5l-1.46-2.62a1.25 1.25 0 0 0-2.16 1.24L7 18.5a6 6 0 0 0 12 0v-5.25a1.25 1.25 0 0 0-2.5 0"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
